import z from 'zod';

export const contactSchema = z.object({
  full_name: z.string().min(1).max(255),
  email: z.string().email(),
  phone: z
    .string()
    .regex(/^\([0-9]{3}\) [0-9]{3}-[0-9]{4}$/)
    .optional(),
  message: z.string().max(10000).optional(),
});

export type IContact = z.infer<typeof contactSchema>;
